import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';

import { historyType } from '../../services/type';

type DateProps = Pick<historyType, 'day' | 'month'>;

export default function DateCard({ day, month }: DateProps) {
  return (
    <Container
      center
      className='relative w-[75px] rounded-[10px] border-[3px] border-[#FFFFFF] bg-[#FFF1ED]  py-4 shadow-[0px_20px_60px_-15px_#00000026]'
    >
      <Text className='text-3xl font-bold leading-9 tracking-tighter'>{day}</Text>
      <Container className='absolute bottom-[-12px] w-[75px] rounded-[16px] border-[3px] border-[#FFFFFF] bg-[#FF6437] py-[2px] shadow-[0px_20px_60px_-15px_#00000026]'>
        <Text className='font-light text-center text-[15px] tracking-tighter text-white'>
          {month}
        </Text>
      </Container>
    </Container>
  );
}
